function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M39.1927 26.0337C38.6719 25.7692 38.5417 25.2404 38.6719 24.976L39.974 20.2163L35.4167 21.1418C35.2865 21.1418 34.7656 21.1418 34.6354 20.2163L34.2448 18.6298L31.1198 22.3317C31.1198 22.3317 29.0365 24.5793 29.6875 21.1418L30.9896 13.8702L28.5156 15.1923C28.3854 15.1923 27.8646 15.3245 27.2135 14.0024L25 9.375L22.6563 13.738C22.0052 15.0601 21.4844 14.9279 21.3542 14.9279L18.8802 13.6058L20.1823 20.8774C20.8333 24.3149 18.75 22.0673 18.75 22.0673L15.625 18.3654L15.2344 19.9519C14.974 20.8774 14.5833 20.8774 14.4531 20.8774L9.89583 19.9519L11.1979 24.7115C11.1979 25.1082 11.1979 25.5048 10.6771 25.7692L9.375 26.5625C9.375 26.5625 14.5833 30.7933 16.276 32.2476C16.6667 32.512 17.4479 33.3053 17.1875 34.2308L16.5365 36.0817L23.6979 35.024C24.0885 35.024 24.8698 35.024 24.7396 36.2139L24.349 43.75H25.651L25.2604 36.2139C25.2604 35.024 26.0417 35.024 26.3021 35.024L33.4635 36.0817L32.8125 34.2308C32.5521 33.3053 33.3333 32.512 33.724 32.2476C35.4167 30.7933 40.625 26.5625 40.625 26.5625L39.1927 26.0337Z",
  fill: "#ED4C5C"
});

var SvgHighDemandBanner = function SvgHighDemandBanner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHighDemandBanner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/high-demand-banner.f7710224.svg";
export { ForwardRef as ReactComponent };